import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { rovoRoute } from '@townsquare/routes/rovo-view';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

const RovoViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "chat-view" */ './components/RovoView'),
	loading: () => null,
});

rovoRoute.component = RovoViewLoadable;
rovoRoute.resources = [rovoEntitlementResource];

export const rovoRouterRoute: GlobalHomePageRoute = rovoRoute;
